export const getNormalizePathname = (pathname: string): string =>
  pathname.replace('/', '');
